"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const polaris_1 = require("@shopify/polaris");
const client_1 = require("@apollo/client");
const launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
const lodash_1 = require("lodash");
const AccountContext_1 = require("contexts/AccountContext");
const ordersCopy_1 = require("copy/ordersCopy");
const DateFormat_1 = require("components/general/utility/DateFormat");
const FormatPagination_1 = require("components/general/utility/FormatPagination");
const ProblemOrdersIcon_1 = require("components/ProblemOrdersIcon");
const StyledHeader_1 = require("components/Dashboard/StyledHeader");
const StyledMainContainer_1 = require("components/Dashboard/StyledMainContainer");
const OrderModal_1 = require("./OrderModal");
const ProblemOrdersRules_1 = require("components/Dashboard/SearchableOrders/ProblemOrdersRules");
const ErrorMessage_1 = require("./ErrorMessage");
const EmptyState_1 = require("./EmptyState");
const graphql_1 = require("./graphql");
const styles_1 = require("./styles");
const react_router_1 = require("react-router");
const queryParams_1 = __importDefault(require("components/general/queryParams/queryParams"));
const utils_1 = require("components/Dashboard/OrderDetails/utils");
const perPage = 12;
const ISSUE_FILTERS = [
    { label: 'All', value: 'ALL' },
    { label: 'Delivery Attempted', value: 'ShipmentDeliveryAttempted' },
    { label: 'Return to Sender', value: 'ShipmentReturnedToSender' },
    { label: 'Stalled in Fulfillment', value: 'FulfillmentStalled' },
    { label: 'Stalled in Transit', value: 'ShipmentStalled' }
];
const STATUS_FILTERS = [
    { label: 'All', value: 'ALL' },
    { label: 'Delivered', value: 'delivered' },
    { label: 'Out for Delivery', value: 'out_for_delivery' },
    { label: 'In Transit', value: 'in_transit' },
    { label: 'Pre Transit', value: 'pre_transit' },
    { label: 'Return to sender', value: 'return_to_sender' },
    { label: 'Available for Pickup', value: 'available_for_pickup' },
    { label: 'Cancelled', value: 'cancelled' },
    { label: 'Bad Tracking Code Error', value: 'bad_tracking_code_error' },
    { label: 'Unknown', value: 'unknown' }
];
function buildFilterLabel(label, values, choiceList) {
    var _a;
    if (values.length) {
        const issuesString = (_a = values === null || values === void 0 ? void 0 : values
        // don't show 'all' in filter tags
        .filter((value) => value !== 'ALL')) === null || _a === void 0 ? void 0 : _a.map((value) => {
            var _a;
            return (((_a = choiceList.find(({ value: filterValue }) => filterValue === value)) === null || _a === void 0 ? void 0 : _a.label) || 'error');
        }).join(', ');
        return `${label}: ${issuesString}`;
    }
    return '';
}
function computeFiltersChange(oldFilters, newFilters, choiceList) {
    let result = [];
    const decreaseFilterCount = !!newFilters && !!oldFilters && newFilters.length < oldFilters.length;
    if ((oldFilters === null || oldFilters === void 0 ? void 0 : oldFilters.includes('ALL')) && decreaseFilterCount) {
        // deselect 'ALL' if one of the filters was deselected while ALL was
        // selected
        result = newFilters.filter((filter) => filter !== 'ALL');
    }
    else if (newFilters === null || newFilters === void 0 ? void 0 : newFilters.includes('ALL')) {
        // If ALL was selected, mark all filters as selected
        result = choiceList.map(({ value }) => value);
    }
    else {
        // regular filter update
        result = newFilters;
    }
    return result;
}
// eslint-disable-next-line complexity
const SearchableOrders = () => {
    const { account } = (0, AccountContext_1.useAccount)();
    const [page, setPage] = (0, queryParams_1.default)('page', 1);
    const [detailedOrderId, setDetailedOrderId] = (0, react_1.useState)();
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const [showProblemOrderRules, setShowProblemOrderRules] = (0, react_1.useState)(false);
    const [carrierChoiceList, setCarrierChoiceList] = (0, react_1.useState)([]);
    const [pagination, setPagination] = (0, react_1.useState)(() => ({
        pageCount: 0,
        label: '0/0',
        isPreviousDisabled: true,
        isNextDisabled: true
    }));
    const [ordersHaveIssues, setOrdersHaveIssues] = (0, react_1.useState)(false);
    const [orders, setOrders] = (0, react_1.useState)([]);
    const [getOrders, { loading, error }] = (0, client_1.useLazyQuery)(graphql_1.GET_SEARCHABLE_ORDERS, {
        onCompleted: ({ searchableOrder }) => {
            var _a;
            // we only want to operate on these after fetch so that we don't compute
            // the order list and pagination on every render
            const orderList = searchableOrder.hits.map(({ document }) => {
                var _a, _b, _c, _d, _e;
                return ({
                    id: document.id,
                    number: document.number,
                    name: document.name,
                    insertedAt: document.inserted_at,
                    placedAt: document.placed_at,
                    customer: document.customer
                        ? {
                            email: (_a = document.customer) === null || _a === void 0 ? void 0 : _a.email,
                            firstName: (_b = document.customer) === null || _b === void 0 ? void 0 : _b.first_name,
                            lastName: (_c = document.customer) === null || _c === void 0 ? void 0 : _c.last_name
                        }
                        : null,
                    shipments: ((_d = document === null || document === void 0 ? void 0 : document.shipments) !== null && _d !== void 0 ? _d : []).map((shipment) => ({
                        carrier: shipment.carrier,
                        status: shipment.status,
                        trackingCode: shipment.tracking_code
                    })),
                    issues: (_e = document === null || document === void 0 ? void 0 : document.issues) !== null && _e !== void 0 ? _e : []
                });
            });
            setOrders(orderList);
            setOrdersHaveIssues(!!orderList.find((order) => order.issues.length > 0));
            const total = (_a = searchableOrder.found) !== null && _a !== void 0 ? _a : 0;
            const pageCount = Math.ceil(total / perPage);
            const isPreviousDisabled = page === 1;
            const isNextDisabled = page === pageCount;
            const paginationLabel = (0, FormatPagination_1.formatPagination)(page, pageCount);
            setPagination({
                pageCount,
                label: paginationLabel,
                isPreviousDisabled,
                isNextDisabled
            });
        }
    });
    (0, client_1.useQuery)(graphql_1.GET_CARRIERS, {
        onCompleted: ({ carriers }) => {
            const carrierList = carriers.map((carrier) => ({
                label: carrier.name,
                value: carrier.code
            }));
            setCarrierChoiceList(carrierList);
        },
        skip: !(account === null || account === void 0 ? void 0 : account.id),
        variables: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            accountId: account.id
        }
    });
    const [searchTerm, setSearchTerm] = (0, queryParams_1.default)('q', '');
    const [searchFieldValue, setSearchFieldValue] = (0, react_1.useState)(() => searchTerm);
    const [problemOrderFilters, setProblemOrderFilters] = (0, queryParams_1.default)('problemOrderFilters', []);
    const [statusFilters, setStatusFilters] = (0, queryParams_1.default)('statusFilters', []);
    const [carrierFilters, setCarrierFilters] = (0, queryParams_1.default)('carrierFilters', []);
    const { id: accountId } = account || {};
    const flags = (0, launchdarkly_react_client_sdk_1.useFlags)();
    const navigate = (0, react_router_1.useNavigate)();
    // watch for account changes
    (0, react_1.useEffect)(() => {
        if (!accountId) {
            return;
        }
        getOrders({
            variables: { input: { accountId, page, perPage } }
        });
    }, [accountId]);
    (0, react_1.useEffect)(() => {
        if (!accountId) {
            return;
        }
        getOrders({
            variables: {
                input: {
                    accountId,
                    page,
                    perPage,
                    q: searchTerm,
                    issues: problemOrderFilters.length ? problemOrderFilters : undefined,
                    shipmentStatuses: statusFilters.length ? statusFilters : undefined,
                    shipmentCarriers: carrierFilters.length ? carrierFilters : undefined
                }
            }
        });
    }, [
        accountId,
        page,
        searchTerm,
        carrierFilters,
        statusFilters,
        problemOrderFilters,
        getOrders
    ]);
    const handleSearch = (0, react_1.useCallback)((query) => {
        setPage(1);
        setSearchTerm(query);
    }, []);
    const debouncedHandleSearch = (0, react_1.useMemo)(() => (0, lodash_1.debounce)(handleSearch, 500), [handleSearch]);
    const onQueryChange = (0, react_1.useCallback)((query) => {
        setSearchFieldValue(query);
        debouncedHandleSearch(query);
    }, [debouncedHandleSearch]);
    const handleToggleModal = () => {
        setShowModal((current) => !current);
    };
    const handleProblemOrdersSelected = (0, react_1.useCallback)((newFilters) => {
        const computedFilters = computeFiltersChange(problemOrderFilters, newFilters, ISSUE_FILTERS);
        setPage(1);
        setProblemOrderFilters(computedFilters);
    }, [problemOrderFilters]);
    const handleStatusesSelected = (0, react_1.useCallback)((newFilters) => {
        const computedFilters = computeFiltersChange(statusFilters, newFilters, STATUS_FILTERS);
        setPage(1);
        setStatusFilters(computedFilters);
    }, [statusFilters]);
    const handleCarriersSelected = (0, react_1.useCallback)((newFilters) => {
        const computedFilters = computeFiltersChange(carrierFilters, newFilters, carrierChoiceList);
        setPage(1);
        setCarrierFilters(computedFilters);
    }, [carrierFilters]);
    const onRowClick = (0, react_1.useCallback)((orderId) => {
        if (flags.orderDetailsPage) {
            navigate(`/orders/${orderId}`);
        }
        else {
            setDetailedOrderId(orderId);
            setShowModal(true);
        }
    }, [flags === null || flags === void 0 ? void 0 : flags.orderDetailsPage]);
    const handleReset = () => {
        setPage(1);
        setSearchTerm('');
        setSearchFieldValue('');
        setCarrierFilters([]);
        setStatusFilters([]);
        setProblemOrderFilters([]);
    };
    const filters = flags.statusFilter
        ? [
            {
                key: 'problemOrders',
                label: 'Problem Orders',
                filter: (react_1.default.createElement(polaris_1.ChoiceList, { allowMultiple: true, choices: ISSUE_FILTERS, onChange: handleProblemOrdersSelected, selected: problemOrderFilters, title: 'Problem Orders', titleHidden: true })),
                shortcut: true
            },
            {
                key: 'shipmentStatus',
                label: 'Status',
                filter: (react_1.default.createElement(polaris_1.ChoiceList, { allowMultiple: true, choices: STATUS_FILTERS, onChange: handleStatusesSelected, selected: statusFilters, title: 'Status', titleHidden: true })),
                hideClearButton: true,
                shortcut: true
            },
            {
                key: 'shipmentCarrier',
                label: 'Carrier',
                filter: (react_1.default.createElement(polaris_1.ChoiceList, { allowMultiple: true, choices: carrierChoiceList, onChange: handleCarriersSelected, selected: carrierFilters, title: 'Carrier', titleHidden: true })),
                hideClearButton: true,
                shortcut: true
            }
        ]
        : [
            {
                key: 'problemOrders',
                label: 'Problem Orders',
                filter: (react_1.default.createElement(polaris_1.ChoiceList, { allowMultiple: true, choices: ISSUE_FILTERS, onChange: handleProblemOrdersSelected, selected: problemOrderFilters, title: 'Problem Orders', titleHidden: true })),
                shortcut: true
            }
        ];
    const appliedFilters = [];
    if (!(0, lodash_1.isEmpty)(problemOrderFilters)) {
        appliedFilters.push({
            key: 'problemOrders',
            label: buildFilterLabel('Problem Orders', problemOrderFilters, ISSUE_FILTERS),
            onRemove: () => handleProblemOrdersSelected([])
        });
    }
    if (!(0, lodash_1.isEmpty)(statusFilters)) {
        appliedFilters.push({
            key: 'statuses',
            label: buildFilterLabel('Status', statusFilters, STATUS_FILTERS),
            onRemove: () => handleStatusesSelected([])
        });
    }
    if (!(0, lodash_1.isEmpty)(carrierFilters)) {
        appliedFilters.push({
            key: 'carriers',
            label: buildFilterLabel('Carrier', carrierFilters, carrierChoiceList),
            onRemove: () => handleCarriersSelected([])
        });
    }
    const resourceName = {
        singular: 'order',
        plural: 'orders'
    };
    const hasFilters = !(0, lodash_1.isEmpty)(problemOrderFilters) || !(0, lodash_1.isEmpty)(statusFilters) || !!searchTerm;
    const rowMarkup = orders.map((order, index) => {
        var _a;
        const customerFullName = (0, utils_1.formatCustomerName)(order.customer);
        const placedDate = order.placedAt
            ? order.placedAt * 1000 // order.placed_at comes from shopify and is stored in seconds, not μsec
            : order.insertedAt;
        return (react_1.default.createElement(polaris_1.IndexTable.Row, { id: order.number, key: order.id, position: index },
            react_1.default.createElement(styles_1.OrderNumberCell, { isProblemOrder: !!order.issues.length },
                ordersHaveIssues && (react_1.default.createElement("div", { className: 'problem-order-icon', "data-testid": 'problem-order-icon' },
                    react_1.default.createElement(polaris_1.Icon, { accessibilityLabel: 'Problem Order', source: ProblemOrdersIcon_1.ProblemOrdersIcon, tone: 'base' }))),
                react_1.default.createElement(polaris_1.Link, { onClick: () => onRowClick(order.id) },
                    react_1.default.createElement(polaris_1.Text, { as: 'span', fontWeight: 'bold' }, order.name || order.number))),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, customerFullName),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, ((_a = order.customer) === null || _a === void 0 ? void 0 : _a.email) || 'N/A'),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null,
                (0, DateFormat_1.shortDateFormat)(placedDate),
                " ",
                (0, DateFormat_1.hourlyFormat)(placedDate)),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, order.shipments.length)));
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, { className: 'orders' },
            react_1.default.createElement(styles_1.HackTableFiltersStyling, null),
            ordersHaveIssues && react_1.default.createElement(styles_1.HackTableHeaderStyling, null),
            react_1.default.createElement(ProblemOrdersRules_1.ProblemOrdersRules, { onHide: () => setShowProblemOrderRules(false), show: showProblemOrderRules }),
            detailedOrderId && (react_1.default.createElement(OrderModal_1.OrderModal, { display: showModal, handleToggleModal: handleToggleModal, orderId: detailedOrderId })),
            react_1.default.createElement(styles_1.StyledHeaderContainer, null,
                react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' },
                    react_1.default.createElement(polaris_1.InlineStack, { blockAlign: 'center', gap: '200' }, ordersCopy_1.ordersCopy.mainHeader)),
                react_1.default.createElement(polaris_1.Button, { "aria-label": 'Problem Order Rules', icon: ProblemOrdersIcon_1.ProblemOrdersIcon, onClick: () => setShowProblemOrderRules(true) }, "Problem orders")),
            react_1.default.createElement(polaris_1.LegacyCard, null,
                react_1.default.createElement(styles_1.TableFiltersContainer, null,
                    react_1.default.createElement(polaris_1.LegacyFilters, { appliedFilters: appliedFilters, filters: filters, key: 'filters', onClearAll: handleReset, onQueryChange: onQueryChange, onQueryClear: () => onQueryChange(''), queryPlaceholder: 'Filter orders', queryValue: searchFieldValue })),
                react_1.default.createElement(polaris_1.IndexTable, { emptyState: error ? (react_1.default.createElement(ErrorMessage_1.ErrorMessage, null)) : (react_1.default.createElement(EmptyState_1.EmptyState, { hasFilters: hasFilters, loading: loading })), headings: [
                        { title: 'Order' },
                        { title: 'Name' },
                        { title: 'Email' },
                        { title: 'Placed' },
                        { title: '# of Shipments' }
                    ], itemCount: orders.length, loading: loading, resourceName: resourceName, selectable: false }, rowMarkup)),
            orders.length > 0 && (react_1.default.createElement(styles_1.PaginationContainer, null,
                react_1.default.createElement(polaris_1.Pagination, { hasNext: !pagination.isNextDisabled, hasPrevious: !pagination.isPreviousDisabled, label: pagination.label, onNext: () => setPage(page + 1), onPrevious: () => setPage(page - 1) }))))));
};
exports.default = SearchableOrders;
